import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import moment from "moment";
import axios from "axios";
import HtmlParser from "react-html-parser";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { HomeUpdatedArrowIcon } from "../../../app-constants";

export default function InsightsStatic() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      className="tekrevol__insights overflow-x-hidden p-100"
      ref={sectionRef}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="Publications">
              <h2>Insights</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="tabs-wrap">
              <Tabs
                defaultActiveKey="blogs"
                id="blog-tab"
                className="blog-tabs "
                justify
              >
                <Tab eventKey="blogs" title="Blogs">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/how-to-build-mobile-apps-with-flutter/"
                          aria-label="How to Build Mobile Apps with Flutter?"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/blog-big-image-2.webp"
                              alt="How to Build Mobile Apps with Flutter?"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/blog-image-2.webp"
                              alt="How to Build Mobile Apps with Flutter?"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              How to Build Mobile Apps with Flutter?
                            </h2>
                            <p>
                              Have you ever wondered how top-tier apps like
                              Google Ads, Alibaba, and Reflectly deliver smooth
                              experiences on both Android and iOS? The secret is
                              Flutter, Google’s ground-breaking UI toolkit.
                              Flutter enables developers to create attractive,
                              high-performance apps for all screens…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">July 30, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/how-to-build-mobile-apps-with-flutter/"
                              aria-label="How to Build Mobile Apps with Flutter?"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/responsive-web-design-essentials-how-to-ensure-your-site-looks-great-on-every-device/"
                          aria-label="Responsive Web Design Essentials: How to Ensure Your Site Looks Great on Every Device"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/blog-big-image-1.webp"
                              alt="Responsive Web Design Essentials: How to Ensure Your Site Looks Great on Every Device"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/blog-image-1.webp"
                              alt="Responsive Web Design Essentials: How to Ensure Your Site Looks Great on Every Device"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              Responsive Web Design Essentials: How to Ensure
                              Your Site Looks Great on Every Device
                            </h2>
                            <p>
                              Today users engage with websites through a wide
                              range of devices and therefore, a consistent user
                              experience is highly desirable. Responsive web
                              design (RWD) is at the head of this mission,
                              making certain that any website can easily adjust
                              to…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">July 22, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/responsive-web-design-essentials-how-to-ensure-your-site-looks-great-on-every-device/"
                              aria-label="Responsive Web Design Essentials: How to Ensure Your Site Looks Great on Every Device"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/what-is-cloud-migration-strategy-process-and-tools/"
                          aria-label="What is Cloud Migration? Strategy, Process, and Tools"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/blog-big-image-3.webp"
                              alt="What is Cloud Migration? Strategy, Process, and Tools"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/blog-image-3.webp"
                              alt="What is Cloud Migration? Strategy, Process, and Tools"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              What is Cloud Migration? Strategy, Process, and
                              Tools
                            </h2>
                            <p>
                              Have you ever wondered how organizations remain
                              adaptable and competitive in an increasingly
                              digital world? Cloud migration is often the
                              solution. Just as people relocate to new places in
                              search of greater opportunities and resources,
                              businesses are migrating to the…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">July 19, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/what-is-cloud-migration-strategy-process-and-tools/"
                              aria-label="What is Cloud Migration? Strategy, Process, and Tools"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="mt-md-5 mt-4"
                  >
                    <div className="btn-wrap text-center">
                      <a
                        href="https://www.tekrevol.com/blogs/"
                        className="btn-pri"
                      >
                        Show more
                      </a>
                    </div>
                  </Col>
                </Tab>
                <Tab eventKey="events" title="Events">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/abeer-raza-ignites-step-conference-2024-with-insights-on-budget-allocation-and-optimization-for-retail-brands/"
                          aria-label="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/events-big-1.webp"
                              alt="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/events-1.webp"
                              alt="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              Abeer Raza Ignites Step Conference 2024 with
                              Insights on “Budget Allocation and Optimization
                              for Retail Brands”
                            </h2>
                            <p>
                              In a riveting session at Step Conference 2024,
                              Abeer Raza, co-founder and CMO TekRevol, took
                              center stage to unravel the intricacies of “Budget
                              Allocation and Optimization for Retail Brands.”
                              The event, renowned for hosting thought leaders
                              and visionaries, witnessed a…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/abeer-raza-ignites-step-conference-2024-with-insights-on-budget-allocation-and-optimization-for-retail-brands/"
                              aria-label="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/tekrevol-leadership-shines-at-tablons-investor-dinner-in-dubai/"
                          aria-label="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/events-big-2.webp"
                              alt="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/events-2.webp"
                              alt="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              TekRevol Leadership Shines at Tablon’s Investor
                              Dinner in Dubai
                            </h2>
                            <p>
                              On the vibrant evening of December 14, 2023, the
                              powerhouse leadership trio of TekRevol—Asim Rais
                              Siddiqui, Abeer Raza, and Behzad Raza—graced
                              Tablon’s Investor Dinner in Dubai with their
                              presence. The event provided a unique platform for
                              networking, fostering new connections,…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/tekrevol-leadership-shines-at-tablons-investor-dinner-in-dubai/"
                              aria-label="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/abeer-razas-insightful-discussion-on-mena-affiliates-roadmap-to-prosperity-at-ifx-expo-dubai/"
                          aria-label="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/events-big-3.webp"
                              alt="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/events-3.webp"
                              alt="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              Abeer Raza’s Insightful Discussion on MENA
                              Affiliates’ Roadmap to Prosperity at iFX EXPO
                              Dubai
                            </h2>
                            <p>
                              In a high-profile appearance at the iFX EXPO
                              Dubai, Abeer Raza, Co-Founder and Chief Marketing
                              Officer of TekRevol, took the stage alongside
                              other industry luminaries to discuss the ‘Roadmap
                              to Prosperity: MENA Affiliates in 2024.’ The
                              event, held on Thursday,…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">February 7, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/abeer-razas-insightful-discussion-on-mena-affiliates-roadmap-to-prosperity-at-ifx-expo-dubai/"
                              aria-label="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </Tab>
                <Tab eventKey="workshops" title="Workshops">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/8-anticipated-marketing-trends-for-2024/"
                          aria-label="8 Anticipated Marketing Trends for 2024"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/workshop-big-1.webp"
                              alt="8 Anticipated Marketing Trends for 2024"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/workshop-1.webp"
                              alt="8 Anticipated Marketing Trends for 2024"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              8 Anticipated Marketing Trends for 2024
                            </h2>
                            <p>
                              As we navigate the evolving landscape of consumer
                              engagement, we’ve gathered insights from eight
                              marketing experts to forecast the trends of 2024.
                              From the haptic technology shift in marketing to
                              eco-focused marketing, these professionals share
                              their predictions on specific marketing…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/8-anticipated-marketing-trends-for-2024/"
                              aria-label="8 Anticipated Marketing Trends for 2024"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/revol-ventures-x-tekrevol-workshop-maps-the-saas-journey-from-idea-to-investment/"
                          aria-label="Revol Ventures x TekRevol Workshop Maps the SaaS Journey from Idea to Investment"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/workshop-big-2.webp"
                              alt="Revol Ventures x TekRevol Workshop Maps the SaaS Journey from Idea to Investment"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/workshop-2.webp"
                              alt="Revol Ventures x TekRevol Workshop Maps the SaaS Journey from Idea to Investment"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              Revol Ventures x TekRevol Workshop Maps the SaaS
                              Journey from Idea to Investment
                            </h2>
                            <p>
                              On February 20th, 2024, the collaboration between
                              Revol Ventures and TekRevol set the stage for an
                              exclusive workshop, “Road to Valuation: Navigating
                              the journey from Idea to Investment.” This event,
                              designed for SaaS entrepreneurs, investors,
                              marketers, product managers, and business…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/revol-ventures-x-tekrevol-workshop-maps-the-saas-journey-from-idea-to-investment/"
                              aria-label="Revol Ventures x TekRevol Workshop Maps the SaaS Journey from Idea to Investment"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/edtech-gamification-webinar-illuminating-the-future-of-learning/"
                          aria-label="EdTech Gamification Webinar Illuminating the Future of Learning"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/workshop-big-3.webp"
                              alt="EdTech Gamification Webinar Illuminating the Future of Learning"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={2560}
                              height={1444}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/workshop-3.webp"
                              alt="EdTech Gamification Webinar Illuminating the Future of Learning"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              EdTech Gamification Webinar Illuminating the
                              Future of Learning
                            </h2>
                            <p>
                              On the 27th of October, education enthusiasts and
                              tech aficionados gathered virtually to explore the
                              dynamic world of EdTech Gamification through a
                              webinar hosted by TekRevol. The webinar featured a
                              lineup of influential speakers and provided a
                              platform for attendees…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/edtech-gamification-webinar-illuminating-the-future-of-learning/"
                              aria-label="EdTech Gamification Webinar Illuminating the Future of Learning"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </Tab>

                <Tab eventKey="podcasts" title="Podcasts">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/artificial-intelligence-the-future-of-content-marketing/"
                          aria-label="Artificial Intelligence & the Future of Content Marketing – Episode 07"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/podcasts-big-1.webp"
                              alt="Artificial Intelligence & the Future of Content Marketing – Episode 07"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={1920}
                              height={1080}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/podcasts-1.webp"
                              alt="Artificial Intelligence & the Future of Content Marketing – Episode 07"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              Artificial Intelligence & the Future of Content
                              Marketing – Episode 07
                            </h2>
                            <p>
                              In the seventh episode of our flagship podcast
                              series, “Technology for a Change,” the host, Mr.
                              Hady Shaikh, invited Ms. Kate Bradley Chernis, a
                              rock n roll DJ turned AI SaaS startup founder, to
                              share her journey of starting a…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/artificial-intelligence-the-future-of-content-marketing/"
                              aria-label="Artificial Intelligence & the Future of Content Marketing – Episode 07"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/unpacking-the-blockchain-revolution-technology-for-change-season-4-episode-1/"
                          aria-label="Unpacking the Blockchain Revolution – Technology for Change Season 4 Episode 1"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/podcasts-big-2.webp"
                              alt="Unpacking the Blockchain Revolution – Technology for Change Season 4 Episode 1"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={1500}
                              height={844}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/podcasts-2.webp"
                              alt="Unpacking the Blockchain Revolution – Technology for Change Season 4 Episode 1"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              Unpacking the Blockchain Revolution – Technology
                              for Change Season 4 Episode 1
                            </h2>
                            <p>
                              In the first episode of our flagship podcast
                              series, “Technology for Change,” we invited Ms.
                              Amalia Grochal, founder of Mirai Dao, to delve
                              into the blockchain revolutions and share her
                              journey in the fintech market with our host, Mr.
                              Hady…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/unpacking-the-blockchain-revolution-technology-for-change-season-4-episode-1/"
                              aria-label="Unpacking the Blockchain Revolution – Technology for Change Season 4 Episode 1"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="blog-item tekrevol_gray_bg">
                        <Link
                          href="https://www.tekrevol.com/blogs/how-to-navigate-career-growth-in-a-changing-world-technology-for-a-change-season-4-episode-3/"
                          aria-label="How to Navigate Career Growth in a Changing World – Technology for a Change Season 4 Episode 3"
                          className="img-link"
                        >
                          {videoLoaded ? (
                            <StaticImage
                              src="../../images/home-update/insights/podcasts-big-3.webp"
                              alt="How to Navigate Career Growth in a Changing World – Technology for a Change Season 4 Episode 3"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={1280}
                              height={720}
                            />
                          ) : (
                            <StaticImage
                              src="../../images/home-update/insights/podcasts-3.webp"
                              alt="How to Navigate Career Growth in a Changing World – Technology for a Change Season 4 Episode 3"
                              className="img-fluid"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={509}
                              height={287}
                            />
                          )}
                        </Link>
                        <div className="content">
                          <div className="inner-wrap">
                            <h2 className="title">
                              How to Navigate Career Growth in a Changing World
                              – Technology for a Change Season 4 Episode 3
                            </h2>
                            <p>
                              The third episode of our flagship podcast series,
                              “Technology for a Change,” featured Mr. Alexander
                              Epure, co-founder and CEO of Qureos. He dove into
                              the potential of vertical farming to transform the
                              agriculture industry with our host, Meghan Hendley
                              Lopez,…
                            </p>
                          </div>
                          <div className="bottom-wrap">
                            {/* <span className="date">May 13, 2024</span> */}
                            <Link
                              href="https://www.tekrevol.com/blogs/how-to-navigate-career-growth-in-a-changing-world-technology-for-a-change-season-4-episode-3/"
                              aria-label="How to Navigate Career Growth in a Changing World – Technology for a Change Season 4 Episode 3"
                              className="box-link"
                            >
                              Learn More {HomeUpdatedArrowIcon}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
